export const SITE = {
  name: "Afurnix",
  tagline: "Premium Furniture & Whole-Home Sourcing",
  base: "Foshan, China",
  email: "hello@afurnix.com",
};

export const NAV_LINKS = [
  { label: "Store", to: "/store" },
  { label: "Collections", to: "/collections" },
  { label: "Projects", to: "/projects" },
  { label: "Services", to: "/services" },
  { label: "Newsroom", to: "/news" },
  { label: "About", to: "/about" },
];

export const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/harjeet_furniturecn" },
  { label: "TikTok", href: "https://www.tiktok.com/@harjeet_furniturecn" },
  { label: "WhatsApp", href: "https://wa.me/message/GEMATYUPDWDTD1" },
  { label: "Facebook", href: "https://www.facebook.com/share/179egax9ZV" },
];

export const WHATSAPP = "https://wa.me/message/GEMATYUPDWDTD1";

export const CATEGORIES = ["All", "Sofas", "Arm Chairs", "Dining", "Beds", "Lighting", "Cabinetry"];
